export default __webpack_public_path__ + "static/media/gestion_propuestas.a91a3258.svg";